"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var helpers = require("./adyen_checkout/helpers");
/* Custom Adyen implementation SFCCR-4977 */
/* Custom Adyen implementation GEC-604 */
var _require = require("adyen/commons"),
  checkIfExpressMethodsAreReady = _require.checkIfExpressMethodsAreReady,
  updateLoadedExpressMethods = _require.updateLoadedExpressMethods,
  createSession = helpers.createSession
/* Custom Adyen implementation end */
/* Custom Adyen implementation end */
var APPLE_PAY = "applepay";
var isSafari = window.ApplePaySession && ApplePaySession.canMakePayments() ? true : false;
var isPDP =  document.querySelectorAll(".product-detail").length > 0; // Custom Adyen implementation GEC-924
/* Custom Adyen implementation end */
var checkout;
var shippingMethodsData;
function initializeCheckout() {
  return _initializeCheckout.apply(this, arguments);
}
/* Custom Adyen implementation SFCCR-4880 */
/**
* Returns an object containing an error message and a new total
* @param {string} field - the field that has an error
* @param {string} errorMessage - the error message
* @param {Object} applePayConfig - the Apple Pay configuration
* @param {boolean} isBilling - whether the error is related to billing
* @returns {Object} - an object containing an error message and a new total
*/
function getAppleErrorMessage(field, errorMessage, applePayConfig, isBilling) {
  if (isBilling) {
    return {
      // Get the total from the application state.
      newTotal: {
        type: "final",
        label: applePayConfig.merchantName,
        amount: 0
      },
      errors: [new ApplePayError('billingContactInvalid', field, errorMessage)]
    };
  }
  return {
    // Get the total from the application state.
    newTotal: {
      type: "final",
      label: applePayConfig.merchantName,
      amount: 0
    },
    errors: [new ApplePayError('shippingContactInvalid', field, errorMessage)]
  };
}
/* Custom Adyen implementation end */
function _initializeCheckout() {
  _initializeCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    /* Custom Adyen implementation GEC-604 */
    var sessionData, shippingMethods;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 5;
          return createSession();
          /* Custom Adyen implementation end */
        case 5:
          sessionData = _context4.sent;
          _context4.next = 8;
          return fetch(window.shippingMethodsUrl);
        case 8:
          shippingMethods = _context4.sent;
          _context4.next = 11;
          return shippingMethods.json();
        case 11:
          shippingMethodsData = _context4.sent;
          /* Custom Adyen implementation GEC-924 Begin */
          // Triggers the 'product:updateQuantity' custom event to update the Apple Pay button amount when the product quantity is changed on PDP
          _context4.next = 14;
          if (isPDP) {
            $("body").trigger("product:updateQuantity", {
              amount: sessionData.grandTotalAmount,
              shippingMethods: shippingMethodsData.shippingMethods
            });
          }
          /* Custom Adyen implementation GEC-924 End */
          return AdyenCheckout({
            environment: window.environment,
            clientKey: window.clientKey,
            locale: window.locale,
            session: sessionData
          });
        case 14:
          checkout = _context4.sent;
        case 15:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _initializeCheckout.apply(this, arguments);
}
function createApplePayButton(_x) {
  return _createApplePayButton.apply(this, arguments);
}
function _createApplePayButton() {
  _createApplePayButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(applePayButtonConfig) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", checkout.create(APPLE_PAY, applePayButtonConfig));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _createApplePayButton.apply(this, arguments);
}
function formatCustomerObject(customerData, billingData) {
  return {
    addressBook: {
      addresses: {},
      preferredAddress: {
        address1: customerData.addressLines[0],
        address2: customerData.addressLines.length > 1 ? customerData.addressLines[1] : null,
        city: customerData.locality,
        countryCode: {
          displayValue: customerData.country,
          value: customerData.countryCode
        },
        firstName: customerData.givenName,
        lastName: customerData.familyName,
        ID: customerData.emailAddress,
        postalCode: customerData.postalCode,
        stateCode: customerData.administrativeArea
      }
    },
    billingAddressDetails: {
      address1: billingData.addressLines[0],
      address2: billingData.addressLines.length > 1 ? billingData.addressLines[1] : null,
      city: billingData.locality,
      countryCode: {
        displayValue: billingData.country,
        value: billingData.countryCode
      },
      firstName: billingData.givenName,
      lastName: billingData.familyName,
      postalCode: billingData.postalCode,
      stateCode: billingData.administrativeArea
    },
    customer: {},
    profile: {
      firstName: customerData.givenName,
      lastName: customerData.familyName,
      email: customerData.emailAddress,
      phone: customerData.phoneNumber
    }
  };
}
function handleAuthorised(response, resolveApplePay) {
  var _response$fullRespons, _response$fullRespons2, _response$fullRespons3, _response$fullRespons4, _response$fullRespons5;
  resolveApplePay();
  document.querySelector("#result").value = JSON.stringify({
    pspReference: (_response$fullRespons = response.fullResponse) === null || _response$fullRespons === void 0 ? void 0 : _response$fullRespons.pspReference,
    resultCode: (_response$fullRespons2 = response.fullResponse) === null || _response$fullRespons2 === void 0 ? void 0 : _response$fullRespons2.resultCode,
    paymentMethod: (_response$fullRespons3 = response.fullResponse) !== null && _response$fullRespons3 !== void 0 && _response$fullRespons3.paymentMethod ? response.fullResponse.paymentMethod : (_response$fullRespons4 = response.fullResponse) === null || _response$fullRespons4 === void 0 ? void 0 : (_response$fullRespons5 = _response$fullRespons4.additionalData) === null || _response$fullRespons5 === void 0 ? void 0 : _response$fullRespons5.paymentMethod
  });
  document.querySelector("#showConfirmationForm").submit();
}
function handleError(rejectApplePay) {
  rejectApplePay();
  document.querySelector("#result").value = JSON.stringify({
    error: true
  });
  document.querySelector("#showConfirmationForm").submit();
}
function handleApplePayResponse(response, resolveApplePay, rejectApplePay) {
  if (response.resultCode === "Authorised") {
    handleAuthorised(response, resolveApplePay);
  } else {
    handleError(rejectApplePay);
  }
}
function callPaymentFromComponent(data, resolveApplePay, rejectApplePay) {
  return $.ajax({
    url: window.paymentFromComponentURL,
    type: "post",
    data: {
      data: JSON.stringify(data),
      paymentMethod: APPLE_PAY
    },
    success: function success(response) {
      helpers.createShowConfirmationForm(window.showConfirmationAction);
      helpers.setOrderFormData(response);
      document.querySelector("#additionalDetailsHidden").value = JSON.stringify(data);
      handleApplePayResponse(response, resolveApplePay, rejectApplePay);
    }
  }).fail(function () {
    rejectApplePay();
  });
}
/* Custom Adyen implementation SFCCR-5090 */
/**
* Validates the name
* @param {string} firstName - the first name to be validated
* @returns {boolean} - true if the first name is valid, false otherwise
*/
function validateName(name) {
  return name && name.trim() !== "";
};

/**
* Validates an email address
* @param {string} email - the email address to validate
* @returns {boolean} - true if the email is valid, otherwise false
*/
function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

/**
* Validates a phone number
* @param {string} phone - the phone number to validate
* @returns {boolean} - true if the phone number is valid, false otherwise
*/
function validatePhone(phone) {
  return /^[\d()+\-.\s]{10,}$/.test(phone);
};

/**
* Decodes a string to HTML
* @param {string} str - the string to decode
* @returns {string} - the decoded HTML string
*/
function decode(str) {
  var div = document.createElement('div');
  div.innerHTML = str;
  return div.innerHTML;
}
/* Custom Adyen implementation end */
/* Custom Adyen implementation GEC-924 Begin */
document.addEventListener('DOMContentLoaded', (e) => {
  if (isSafari) {
  var applePayButtonConfig = {};
  $("body").on("personalization:opened", function(e) {
    e.preventDefault();
    helpers.mountApplePayButtons(applePayButtonConfig, createApplePayButton, APPLE_PAY);
    helpers.setApplePayExpressPDPEvent();
  });
  $("body").on("product:updateQuantity", function (e, data) {
    // Recalculate the total amount based on the new quantity
    e.preventDefault();
    applePayButtonConfig.amount = data.amount;
    applePayButtonConfig.shippingMethods = data.shippingMethods.map(function (sm) {
        return {
          label: sm.displayName,
          detail: sm.description,
          identifier: sm.ID,
          amount: "".concat(sm.shippingCost.value)
        };
      });
    if (checkout) {
      helpers.mountApplePayButtons(applePayButtonConfig, createApplePayButton, APPLE_PAY);
    }
  });
  $("body").on("input", "#personalization-form .personalization-input-message", function(e) {
    this.value = this.value.toUpperCase();
    const isFormValid = this.validity.valid;
    if (isFormValid) {
      createSession().then(function(response) {
          applePayButtonConfig.amount = response.grandTotalAmount;
          helpers.mountApplePayButtons(applePayButtonConfig, createApplePayButton, APPLE_PAY);
      });
    }
    
  });
  $("body").on("personalization:closed", function() {
    createSession().then(function(response) {
      applePayButtonConfig.amount = response.grandTotalAmount;
      helpers.mountApplePayButtons(applePayButtonConfig, createApplePayButton, APPLE_PAY);
    })
  });
  /* Custom Adyen implementation GEC-924 End */
  initializeCheckout().then(function () {
    var applePayPaymentMethod = checkout.paymentMethodsResponse.paymentMethods.find(function (pm) {
      return pm.type === APPLE_PAY;
    });
    if (!applePayPaymentMethod) {
      updateLoadedExpressMethods(APPLE_PAY);
      checkIfExpressMethodsAreReady();
      return;
    }
    var applePayConfig = applePayPaymentMethod.configuration;
    applePayButtonConfig = { // Custom Adyen implementation GEC-924
      showPayButton: true,
      buttonColor: "white-with-line", // Custom Adyen implementation SFCCR-4977
      configuration: applePayConfig,
      amount: checkout.options.amount,
      requiredShippingContactFields: ["postalAddress", "email", "phone"],
      requiredBillingContactFields: ["postalAddress", "phone"],
      shippingMethods: shippingMethodsData.shippingMethods.map(function (sm) {
        return {
          label: sm.displayName,
          detail: sm.description,
          identifier: sm.ID,
          amount: "".concat(sm.shippingCost.value)
        };
      }),
      onAuthorized: function () {
        var _onAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject, event) {
          var customerData, billingData, customer, stateData, resolveApplePay;
          /* Custom Adyen implementation SFCCR-5090 */
          if (event.type === "paymentauthorized") {
                    let update = {};
                    let validated = true;
                    let unparsedErrorMessages = decode(window.adyenErrorMessages);
                    let errorMessages = JSON.parse(unparsedErrorMessages);
                    // complete customer data is available only in this event and shippingContact 
                    // should have already been validated by onShippingMethodSelected event
                    customerData = event.payment.shippingContact;
                    billingData = event.payment.billingContact;
                    if (!validateName(billingData.postalCode)) {
                        update = getAppleErrorMessage("postalCode", errorMessages.postalCodeMessage, applePayConfig, true);
                        resolve(update);
                        validated = false;
                    } else if (!validateName(customerData.familyName) || !validateName(customerData.givenName)) {
                        update = getAppleErrorMessage("name", errorMessages.lastNameMessage, applePayConfig);
                        resolve(update);
                        validated = false;
                    } else if (!validateName(billingData.familyName) || !validateName(billingData.givenName)) {
                        update = getAppleErrorMessage("name", errorMessages.lastNameMessage, applePayConfig, true);
                        resolve(update);
                        validated = false;
                    } else if (!validateEmail(customerData.emailAddress)) {
                        update = getAppleErrorMessage("emailAddress", errorMessages.emailMessage, applePayConfig);
                        resolve(update);
                        validated = false;
                    } else if (!validatePhone(customerData.phoneNumber)) {
                        update = getAppleErrorMessage("phoneNumber", errorMessages.phoneMessage, applePayConfig);
                        resolve(update);
                        validated = false;
                    } else if (!validateName(billingData.locality)) {
                        update = getAppleErrorMessage("locality", errorMessages.billingLocalityMessage, applePayConfig, true);
                        resolve(update);
                        validated = false;
                    } else if (billingData.addressLines.length && !validateName(billingData.addressLines[0])) {
                        update = getAppleErrorMessage("addressLines", errorMessages.billingAddress1Message, applePayConfig, true);
                        resolve(update);
                        validated = false;
                    } else if (customerData.addressLines.length && !validateName(customerData.addressLines[0])) {
                        update = getAppleErrorMessage("addressLines", errorMessages.billingAddress1Message, applePayConfig);
                        resolve(update);
                        validated = false;
                    }

                    if (validated) {
                        return _regeneratorRuntime().wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              _context.prev = 0;
                              customer = formatCustomerObject(customerData, billingData);
                              stateData = {
                                paymentMethod: {
                                  type: APPLE_PAY,
                                  applePayToken: event.payment.token.paymentData
                                },
                                paymentType: "express"
                              };
                              resolveApplePay = function resolveApplePay() {
                                var finalPriceUpdate = {
                                  newTotal: {
                                    type: "final",
                                    label: applePayConfig.merchantName,
                                    amount: "".concat(applePayButtonConfig.amount.value / 100)
                                  }
                                };
                                resolve(finalPriceUpdate);
                              };
                              _context.next = 8;
                              return callPaymentFromComponent(_objectSpread(_objectSpread({}, stateData), {}, {
                                customer: customer
                              }), resolveApplePay, reject);
                            case 8:
                              _context.next = 13;
                              break;
                            case 10:
                              _context.prev = 10;
                              _context.t0 = _context["catch"](0);
                              reject(_context.t0);
                            case 13:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee, null, [[0, 10]]);
                    } else {
                        return _regeneratorRuntime().wrap(function _callee$(_context) {
                          return _context.stop();
                        }, _callee, null, [[0, 10]]);
                    }
          }
          /* Custom Adyen implementation end */
        }));
        function onAuthorized(_x2, _x3, _x4) {
          return _onAuthorized.apply(this, arguments);
        }
        return onAuthorized;
      }(),
      onSubmit: function onSubmit() {
        // This handler is empty to prevent sending a second payment request
        // We already do the payment in paymentFromComponent
      },
      onShippingMethodSelected: function () {
        var _onShippingMethodSelected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject, event) {
          var shippingMethod, matchingShippingMethod, calculationResponse, newCalculation, applePayShippingMethodUpdate;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                shippingMethod = event.shippingMethod;
                matchingShippingMethod = shippingMethodsData.shippingMethods.find(function (sm) {
                  return sm.ID === shippingMethod.identifier;
                });
                _context2.next = 4;
                return fetch("".concat(window.calculateAmountUrl, "?").concat(new URLSearchParams({
                  shipmentUUID: matchingShippingMethod.shipmentUUID,
                  methodID: matchingShippingMethod.ID
                })), {
                  method: "POST"
                });
              case 4:
                calculationResponse = _context2.sent;
                if (!calculationResponse.ok) {
                  _context2.next = 14;
                  break;
                }
                _context2.next = 8;
                return calculationResponse.json();
              case 8:
                newCalculation = _context2.sent;
                applePayButtonConfig.amount = {
                  value: newCalculation.grandTotalAmount.value,
                  currency: newCalculation.grandTotalAmount.currency
                };
                applePayShippingMethodUpdate = {
                  newTotal: {
                    type: "final",
                    label: applePayConfig.merchantName,
                    amount: newCalculation.grandTotalAmount.value
                  }
                };
                resolve(applePayShippingMethodUpdate);
                _context2.next = 15;
                break;
              case 14:
                reject();
              case 15:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function onShippingMethodSelected(_x5, _x6, _x7) {
          return _onShippingMethodSelected.apply(this, arguments);
        }
        return onShippingMethodSelected;
      }(),
      onShippingContactSelected: function () {
        var _onShippingContactSelected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject, event) {
        /* Custom Adyen implementation SFCCR-4880 */
        // check country and required fields
        const { locality } = event && event.shippingContact ? event.shippingContact : "";
        let update = {};

        let url = ("".concat(window.validateShippingAddressURL, "?").concat(new URLSearchParams(
            {
                data: JSON.stringify(event.shippingContact)
            }
        )));

        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (!data.countryCode) {
                    update = getAppleErrorMessage("countryCode", data.countryMessage, applePayConfig);
                    resolve(update);
                    return;
                } else if (!data.postalCode) {
                    update = getAppleErrorMessage("postalCode", data.postalCodeMessage, applePayConfig);
                    resolve(update);
                    return;
                } else if (locality === "") {
                    update = getAppleErrorMessage("locality", data.cityMessage, applePayConfig);
                    resolve(update);
                    return;
                }
            });

        /* Custom Adyen implementation end */
          var shippingContact, shippingMethods, _shippingMethodsData$, selectedShippingMethod, calculationResponse, shippingMethodsStructured, newCalculation, applePayShippingContactUpdate;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                shippingContact = event.shippingContact;
                _context3.next = 3;
                return fetch("".concat(window.shippingMethodsUrl, "?").concat(new URLSearchParams({
                  city: shippingContact.locality,
                  country: shippingContact.country,
                  countryCode: shippingContact.countryCode,
                  stateCode: shippingContact.administrativeArea,
                  postalCode:shippingContact.postalCode, // Custom Adyen implementation SFCCR-4977
                })));
              case 3:
                shippingMethods = _context3.sent;
                if (!shippingMethods.ok) {
                  _context3.next = 28;
                  break;
                }
                _context3.next = 7;
                return shippingMethods.json();
              case 7:
                shippingMethodsData = _context3.sent;
                if (!((_shippingMethodsData$ = shippingMethodsData.shippingMethods) !== null && _shippingMethodsData$ !== void 0 && _shippingMethodsData$.length)) {
                  _context3.next = 25;
                  break;
                }
                selectedShippingMethod = shippingMethodsData.shippingMethods[0];
                _context3.next = 12;
                return fetch("".concat(window.calculateAmountUrl, "?").concat(new URLSearchParams({
                  shipmentUUID: selectedShippingMethod.shipmentUUID,
                  methodID: selectedShippingMethod.ID
                })), {
                  method: "POST"
                });
              case 12:
                calculationResponse = _context3.sent;
                if (!calculationResponse.ok) {
                  _context3.next = 22;
                  break;
                }
                shippingMethodsStructured = shippingMethodsData.shippingMethods.map(function (sm) {
                  return {
                    label: sm.displayName,
                    detail: sm.description,
                    identifier: sm.ID,
                    amount: "".concat(sm.shippingCost.value)
                  };
                });
                _context3.next = 17;
                return calculationResponse.json();
              case 17:
                newCalculation = _context3.sent;
                applePayShippingContactUpdate = {
                  newShippingMethods: shippingMethodsStructured,
                  newTotal: {
                    type: "final",
                    label: applePayConfig.merchantName,
                    amount: newCalculation.grandTotalAmount.value
                  }
                };
                resolve(applePayShippingContactUpdate);
                _context3.next = 23;
                break;
              case 22:
                reject();
              case 23:
                _context3.next = 26;
                break;
              case 25:
                reject();
              case 26:
                _context3.next = 29;
                break;
              case 28:
                reject();
              case 29:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function onShippingContactSelected(_x8, _x9, _x10) {
          return _onShippingContactSelected.apply(this, arguments);
        }
        return onShippingContactSelected;
      }()
    };
    var cartContainer = document.getElementsByClassName(APPLE_PAY);
    var _loop = function _loop(expressCheckoutNodesIndex) {
      createApplePayButton(applePayButtonConfig).then(function (applePayButton) {
        var isApplePayButtonAvailable = applePayButton.isAvailable();
        if (isApplePayButtonAvailable) {
          applePayButton.mount(cartContainer[expressCheckoutNodesIndex]);
        }
      });
    };
    for (var expressCheckoutNodesIndex = 0; expressCheckoutNodesIndex < cartContainer.length; expressCheckoutNodesIndex += 1) {
      _loop(expressCheckoutNodesIndex);
    }
    updateLoadedExpressMethods(APPLE_PAY);
    checkIfExpressMethodsAreReady();
    helpers.setApplePayExpressCheckoutCTAEvent();
  })["catch"](function () {
    updateLoadedExpressMethods(APPLE_PAY);
    checkIfExpressMethodsAreReady();
    helpers.setApplePayExpressCheckoutCTAEvent();
  });
} else {
  updateLoadedExpressMethods(APPLE_PAY);
  checkIfExpressMethodsAreReady();
  helpers.setApplePayExpressCheckoutCTAEvent();
}
});
module.exports = {
  handleAuthorised: handleAuthorised,
  handleError: handleError,
  handleApplePayResponse: handleApplePayResponse,
  callPaymentFromComponent: callPaymentFromComponent,
  initializeCheckout: initializeCheckout // Custom Adyen implementation GEC-924
};
